import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

const BackToTop = () => {
    const [visible, setVisible] = useState(false);
    const [footerVisible, setFooterVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();

        const footer = document.querySelector("footer");
        let observer;
        if (footer) {
            observer = new IntersectionObserver(([entry]) => setFooterVisible(entry.isIntersecting), { threshold: 0.05 });
            observer.observe(footer);
        }
        return () => {
            window.removeEventListener("scroll", onScroll);
            observer?.disconnect();
        };
    }, []);

    return (
        <AnimatePresence>
            {visible && !footerVisible && (
                <motion.a
                    href="#inicio"
                    aria-label="Retornar ao topo da página"
                    data-testid="back-to-top-button"
                    initial={{ opacity: 0, x: "-50%", y: 24, scale: 0.8 }}
                    animate={{ opacity: 1, x: "-50%", y: 0, scale: 1 }}
                    exit={{ opacity: 0, x: "-50%", y: 24, scale: 0.8 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-6 left-1/2 z-50 flex h-14 w-14 items-center justify-center rounded-full border border-lilac/50 bg-white/90 text-plum shadow-xl shadow-plum/15 backdrop-blur-md transition-colors duration-300 hover:bg-lav"
                >
                    <ArrowUp size={22} />
                </motion.a>
            )}
        </AnimatePresence>
    );
};

export default BackToTop;
